/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1 15h3L14.295 4.705c.39-.39.384-1.026-.006-1.416l-1.578-1.578a1.003 1.003 0 00-1.416-.006L1 12v3zM9 4l3 3" _stroke="currentColor" stroke-width="2" _fill="none"/><path pid="1" d="M1 15v-3l3 3H1z" _fill="currentColor"/>'
  }
})
